import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-[#0A2D50] text-white py-16">
      <div className="max-w-[1440px] mx-auto px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/imprint"
                  className="text-sm text-white/70 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
                >
                  {t('footer.imprint')}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-white/70 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
                >
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-settings"
                  className="text-sm text-white/70 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
                >
                  {t('footer.cookieSettings')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-2">
              <li className="text-sm text-white/70">
                DR Group GmbH
              </li>
              <li className="text-sm text-white/70">
                In der Gottesau 4
              </li>
              <li className="text-sm text-white/70">
                76646 Bruchsal, Germany
              </li>
              <li>
                <a
                  href="mailto:info@group-dr.com"
                  className="text-sm text-white/70 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
                >
                  info@group-dr.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+491708843942"
                  className="text-sm text-white/70 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
                >
                  +49 170 8843 942
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.registerCourt')}</h3>
            <ul className="space-y-2">
              <li className="text-sm text-white/70">
                Amtsgericht Mannheim
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/60">
            {t('footer.copyright')}
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/60 hover:text-[#1BCDFF] transition-colors duration-200 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}